import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=27c1a8a4&"
import script from "./Scanner.vue?vue&type=script&lang=js&"
export * from "./Scanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports